import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from 'react-router-dom';
import App from "./App";

import { I18nextProvider } from "react-i18next";
import { initReactI18next } from 'react-i18next'
import i18next from "i18next";

import common_en from "./translations/en/common.json";
import common_fr from "./translations/fr/common.json";

import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng'
}

i18next
.use(LanguageDetector)
.use(initReactI18next)
.init({
  detection: options,
  interpolation: { escapeValue: false },  // React already does escaping
  //lng: 'fr',                              // language to use
  resources: {
      en: {
          common: common_en               // 'common' is our custom namespace
      },
      fr: {
          common: common_fr
      },
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <I18nextProvider i18n={i18next}>
    <Router>
      <App />
    </Router>
  </I18nextProvider>

);

